export const getWhoLiked = (state, postOrCommentId) =>
  state.whoLiked[postOrCommentId] || { items: [], lastPage: 0 };
